import moment from "moment";

const HomeCustomTick = ({ x, y, payload, index, data }) => {
  const day = moment(payload.value).format("D일");
  const month = moment(payload.value).format("M월");

  const shouldShowMonth =
    index === 0 ||
    (data &&
      data[index - 1] &&
      moment(payload.value).format("M") !==
        moment(data[index - 1].date).format("M"));

  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={30} textAnchor="middle">
        <tspan
          x="0"
          dy="0"
          fill="#aaa"
          style={{
            fontFamily: "Pretendard",
            fontWeight: 400,
            fontSize: 14,
            lineHeight: "20.25px",
          }}
        >
          {day}
        </tspan>
        {shouldShowMonth ? (
          <tspan
            x="0"
            dy="20"
            fill="rgba(181, 181, 181, 0.5)"
            style={{
              fontFamily: "Pretendard",
              fontWeight: 400,
              fontSize: 14,
              lineHeight: "20.25px",
            }}
          >
            {month}
          </tspan>
        ) : null}
      </text>
    </g>
  );
};

export default HomeCustomTick;
